export default {
  path: '/printers',
  name: 'printers',
  component: () => import('../components/printer/Layout'),
  redirect: { name: 'PrinterList' },
  meta: {
    breadcrumb: 'printer.printers',
  },
  children: [
    {
      name: 'PrinterList',
      path: '',
      component: () => import('../views/printer/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'PrinterCreate',
      path: 'new',
      component: () => import('../views/printer/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'PrinterUpdate',
      path: ':id/edit',
      component: () => import('../views/printer/Update'),
      meta: {
        breadcrumb: 'printer.printer',
      },
    },
    {
      name: 'PrinterShow',
      path: ':id',
      component: () => import('../views/printer/Show'),
      meta: {
        breadcrumb: 'printer.printer',
      },
    }
  ]
};
